import { useDispatch } from 'react-redux';
import { previous, next } from 'redux/stepSlice';

const useNavigation = () => {
  const dispatch = useDispatch();
  return {
    previous: () => dispatch(previous()),
    next: () => dispatch(next())
  };
};

export default useNavigation;
